import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'xp-badge',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './xp-badge.component.html',
	styleUrls: ['./xp-badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpBadgeComponent {
	icon = input<string | null>(null);
	iconSrc = input<string | null>(null);
	dot = input(false);
	pulse = input(false);

	@HostBinding('class.xp-badge--pulse')
	get isPulsing(): boolean {
		return this.pulse();
	}
}
